export const LOAD_ERRORS = 'LOAD_ERRORS';
export const SET_ERRORS_PAGINATION = 'SET_ERRORS_PAGINATION';
export const SET_ERRORS_SORT = 'SET_ERRORS_SORT';
export const SET_ERRORS_FILTERS = 'SET_ERRORS_FILTERS';
export const RESET_ERRORS_FILTERS = 'RESET_ERRORS_FILTERS';
export const TOGGLE_ERRORS_STATUS = 'TOGGLE_ERRORS_STATUS';
